interface IPatient {
  firstName: string
  lastName: string
}

export const getPatientFullName = (patient: IPatient): string =>
  ((patient.firstName || '') + ' ' + (patient.lastName || '')).trim()
